import { PureComponent, ReactNode } from "react";
import RatingEstimatesPercentageCoursesStates, { RatingEstimatesCourseType, RatingEstimatesPercentageCoursesProps } from "./RatingEstimatesPercentageCourses.models";
import './RatingEstimatesPercentageCourses.scss';
import formImage from '../../../assest/images/exam/takhminRotbeForm3.png';
import CircularProgressBar from "../../shared/circular-progress-bar/CircularProgressBar";
import { NavLink } from "react-router-dom";

export default class RatingEstimatesPercentageCourses extends PureComponent<RatingEstimatesPercentageCoursesProps, RatingEstimatesPercentageCoursesStates>{
    constructor(props: any) {
        super(props);
        this.state = { data: [] };
    }

    componentDidMount() {
        if (this.props.dept !== null && this.props.dept !== undefined)
            this.fullData(this.props.dept);
    }
    componentDidUpdate(prevProps: any) {
        if (prevProps.dept !== this.props.dept && this.props.dept !== null && this.props.dept !== undefined)
            this.fullData(this.props.dept);
    }

    fullData = (group: number) => {
        if (group == 0) {
            this.setState({
                data: [{ label: 'ادبيات', value: 0 }, { label: 'عربي', value: 0 }, { label: 'دینی', value: 0 }, { label: 'زبان', value: 0 }
                    , { label: 'رياضي', value: 0 }
                    , { label: 'فيزيك', value: 0 }
                    , { label: 'شيمي', value: 0 }]
            })
        }
        else if (group == 1) {
            this.setState({
                data: [{ label: 'ادبيات', value: 0 }, { label: 'عربي', value: 0 }, { label: 'دینی', value: 0 }, { label: 'زبان', value: 0 }
                    , { label: 'رياضي', value: 0 }
                    , { label: 'فيزيك', value: 0 }
                    , { label: 'شيمي', value: 0 }
                    , { label: 'زيست‌شناسي', value: 0 }]
            })

        }
        else if (group == 2) {
            this.setState({
                data: [{ label: 'ادبيات', value: 0 }, { label: 'عربي', value: 0 }, { label: 'دینی', value: 0 }, { label: 'زبان', value: 0 }
                    , { label: 'رياضي', value: 0 }
                    , { label: 'اقتصاد', value: 0 }
                    , { label: 'ادبيات اختصاصي', value: 0 }
                    , { label: 'عربي اختصاصي', value: 0 }
                    , { label: 'تاريخ و جغرافي', value: 0 }
                    , { label: 'علوم اجتماعي', value: 0 }
                    , { label: 'فلسفه و منطق', value: 0 }
                    , { label: 'روانشناسي', value: 0 }]
            })
        }

    }

    onChange = (index: any, value: any) => {
        var datas = this.state.data;
        datas[index].value = value;
        this.setState({ data: datas });
        var data: RatingEstimatesCourseType = { label: datas[index].label, value: value };
        this.props.onPrecentChangeHandle(data);
        this.forceUpdate();
    }

    render(): ReactNode {

        return <>
            <div className="rating-estimates-percentage-courses-area dropdown-list mt-2">
                <div className="tk-card">
                    <div className="col-12">
                        <div className="icon">
                            <img src={formImage} width="64" height="64" alt="request exam" />
                        </div>
                        <div className="title">
                            <label>درصد دروس</label>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="tk-boby">
                            <div className="bd-title">
                                <label>درصدها را با چرخاندن پیچ ها مشخص کنید</label>
                            </div>
                            <div className="exam-content">
                                <div className="row pt-3 pb-3">
                                    {this.state.data.map((course, key) => {
                                        return (<div key={key} className="col-4">
                                            <CircularProgressBar value={course.value} indexValue={key} label={course.label} onHandle={this.onChange} />
                                        </div>)
                                    })}
                                </div>
                                <div className="col-12">
                                    <div className="col-12 notspace">
                                        <button onClick={() => this.props.handleRequest(this.state.data)} style={{ width: "100%" }} type="submit" className="btn btn-primary">
                                            تخمین رتبه
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>;
    }
}